module.exports = __webpack_public_path__ + "img/260-united-kingdom.55c0f042.svg";